//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../../media/MediaQuery";

//css
import styled from "styled-components";
// component
import MyPageProduct from "../../../../component/content/MyPageProduct";
import Pagination from "../../../../component/pagination/Pagination";
import BasicBtn from "../../../../component/button/BasicBtn";
import DefaultPop from "../../../../component/popup/DefaultModal";
// img
import couponBg from "../../../../assets/img/icon/coupon.svg";

// responsive
import { M, T } from "../../../../utils/MT";

export default function MyCoupon(props) {
    // 적립금 내역 리스트
    const [couponData, setCouponData] = useState([]);

    useEffect(() => {
        const CouponList = [
            {
                name: "신규회원 환영 쿠폰",
                date: "2021.01.14 ~ 2021.03.14",
                coupon: "10%",
            },
            {
                name: "출시기념 할인쿠폰",
                date: "2021.01.14 ~ 2021.03.14",
                coupon: "5%",
                option: "옵션있을시 작성",
            },
            {
                name: "신규회원 환영 쿠폰",
                date: "2021.01.14 ~ 2021.03.14",
                coupon: "10%",
            },
            {
                name: "출시기념 할인쿠폰",
                date: "2021.01.14 ~ 2021.03.14",
                coupon: "5%",
                option: "옵션있을시 작성",
            },
        ];
        setCouponData(CouponList);
    }, []);

    return (
        <Wrap>
            <MyCouponSection>
                {/* 쿠폰 */}
                <MyCouponTitle>쿠폰</MyCouponTitle>

                <CouponBoxWrap>
                    <CouponBoxTitle>사용가능 쿠폰</CouponBoxTitle>

                    <CouponBoxList>
                        {/* 사용가능한 쿠폰이 없을 경우 */}
                        {/* <NotCoupon>사용가능한 쿠폰이 없습니다.</NotCoupon> */}
                        {couponData.map((item, index) => {
                            return (
                                <CouponBox key={index}>
                                    <CouponTextBox>
                                        <CouponName>{item.name}</CouponName>
                                        <CouponDate>{item.date}</CouponDate>
                                        <CouponOption>{item.option}</CouponOption>
                                    </CouponTextBox>
                                    <CouponPrice>{item.coupon}</CouponPrice>
                                </CouponBox>
                            );
                        })}
                    </CouponBoxList>
                </CouponBoxWrap>

                {/* 페이징 */}
                <Paging>
                    <Pagination />
                </Paging>
            </MyCouponSection>
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;
    }
`;
const MyCouponSection = styled.div``;
const MyCouponTitle = styled.h2`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;
const Paging = styled.div`
    margin-top: calc(100vw * (60 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (60 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(60)};
    }
`;
const CouponBoxWrap = styled.div`
    margin-top: calc(100vw * (20 / 1920));
    border-top: 1px solid #222;

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(20)};
    }
`;
const CouponBoxTitle = styled.p`
    margin-top: calc(100vw * (40 / 1920));
    font-size: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (40 / 1300));
        font-size: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(40)};
        font-size: ${M(16)};
    }
`;
const CouponBoxList = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    margin-top: calc(100vw * (20 / 1920));

    & ul:nth-child(odd) {
        margin-right: calc(100vw * (40 / 1920));
        margin-bottom: calc(100vw * (20 / 1920));
    }

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));

        & ul:nth-child(odd) {
            margin-right: calc(100vw * (40 / 1300));
            margin-bottom: calc(100vw * (20 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(20)};

        & ul:nth-child(odd) {
            margin-right: 0;
            margin-bottom: ${M(20)};
        }
    }
`;
const CouponBox = styled.ul`
    display: flex;
    align-items: center;
    justify-content: center;

    background: url(${couponBg}) no-repeat;
    width: calc(100vw * (400 / 1920));
    height: calc(100vw * (125 / 1920));
    background-size: contain;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (400 / 1300));
        height: calc(100vw * (125 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        height: ${M(125)};
        margin-bottom: ${M(20)};
    }
`;
const CouponTextBox = styled.li`
    max-width: calc(100vw * (195 / 1920));

    border-right: 1px solid #dddddd;
    padding-right: calc(100vw * (45 / 1920));

    @media screen and (max-width: 1300px) {
        max-width: calc(100vw * (195 / 1300));
        padding-right: calc(100vw * (45 / 1300));
    }

    @media screen and (max-width: 900px) {
        max-width: ${M(195)};
        padding-right: ${M(45)};
    }
`;
const CouponName = styled.p`
    margin-bottom: calc(100vw * (10 / 1920));

    font-size: calc(100vw * (18 / 1920));

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (10 / 1300));
        font-size: calc(100vw * (18 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(10)};
        font-size: ${M(18)};
    }
`;
const CouponDate = styled.p`
    font-size: calc(100vw * (13 / 1920));

    color: #aaaaaa;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;
const CouponPrice = styled.p`
    font-size: calc(100vw * (25 / 1920));
    padding-left: calc(100vw * (45 / 1920));

    color: var(--main-color);

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
        padding-left: calc(100vw * (45 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-family: "Noto-B";
        font-size: ${M(25)};
        padding-left: ${M(45)};
    }
`;
const CouponOption = styled.p`
    width: calc(100vw * (140 / 1920));
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    font-size: calc(100vw * (13 / 1920));

    margin-top: calc(100vw * (5 / 1920));
    color: #dddddd;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (140 / 1300));
        font-size: calc(100vw * (13 / 1300));
        margin-top: calc(100vw * (5 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(140)};
        font-size: ${M(13)};
        margin-top: ${M(5)};
    }
`;
const NotCoupon = styled.p`
    margin: calc(100vw * (100 / 1920)) 0;
    text-align: center;
    font-size: calc(100vw * (14 / 1920));
    color: #909090;

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (100 / 1300)) 0;
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin: ${M(100)} 0;
        font-size: ${M(14)};
    }
`;
